export default __webpack_public_path__ + "fb116a55e56240ecd88e99c9d99a0b77.svg";